module.exports = __webpack_public_path__ + "img/sld_acdb_mfm.02b54ef5.svg";